export default __webpack_public_path__ + "static/media/skin2_sprites.9fcf2f14.png";